export enum PortalMessageType {
    Notification,
    Warning,
    Maintenance
}